
export class UserSignupModel {
    email:any;
    fullName:any;
    referralCode:any;
    ethAddress:any;
    password:any;
    cPassword:any;
    username:any;
    ETHWalleRecieverData:any;
    Language: any;
    country: string
    mobile: string
}